module.exports = __webpack_public_path__ + "assets/img/recipe-3.54b91c2e.jpg";